import { PaginaNode, SoluzioneNode } from '@gql/graphql'
import { useFindMenu, useTrans } from 'hooks'
import { PlaceholderReact } from '@components/molecules'
import {
  CardSwiper,
  CollezioniSection,
  GenericHero,
  Page,
  Prefooter,
  SoluzioniSection,
} from 'components/organisms'
import styles from './SoluzioniDetailTemplate.module.sass'
import { useEffect } from 'react'
import { collezioneToTrack, trackingEcommerceEvent } from '@utils/gtm'

interface Props {
  pagina?: PaginaNode
  soluzione?: SoluzioneNode
  collezioni?: any[]
}

const SoluzioniDetailTemplate = (props: Props) => {
  const { pagina = undefined, soluzione = undefined, collezioni = [] } = props

  const t = useTrans()
  const soluzioniMenu = useFindMenu('pagina-soluzioni-detail')
  const collezioniMenu = useFindMenu('collezioni-slider', soluzioniMenu)
  const collezioniMenuSoluzioni = useFindMenu(`${soluzione.slug}`, soluzioniMenu)
  const correlatiMenu = useFindMenu('correlati-slider', soluzioniMenu)

  const defaultContent1 = soluzione?.pagebuilders?.find((x) => x.key === 'main') ?? null

  const handleClickTracking = (item, index) => {
    trackingEcommerceEvent('select_item', {
      item_list_id: soluzione?.pk,
      item_list_name: soluzione?.slug || '',
      items: [collezioneToTrack(item, index, soluzione)],
    })
  }

  useEffect(() => {
    if (!soluzione?.categorie?.length)
      trackingEcommerceEvent('view_item_list', {
        item_list_id: soluzione?.pk,
        item_list_name: soluzione?.slug || '',
        items: collezioni.map((p, index) => {
          return collezioneToTrack(p, index, soluzione)
        }),
      })
  }, [])

  return (
    <Page pagina={pagina} className={`${styles.root}`} item={soluzione}>
      <main>
        <GenericHero
          pagina={{
            ...pagina,
            titolo: soluzione?.title,
            descrizione: `${
              soluzione.subtitle ? `<h2 class="heading2">${soluzione.subtitle}</h2>` : ''
            }${soluzione.description || ''}`,
          }}
        />
        <div className={styles.placeholderContent}>
          <PlaceholderReact
            contentTypeId={soluzione.model}
            objectId={soluzione.pk}
            pkey={'main'}
            serverSideContent={defaultContent1}
          />
        </div>
        {soluzione.categorie.length ? (
          <CardSwiper
            id="soluzioni-categorie-swiper"
            item={{
              ...(collezioniMenu || collezioniMenuSoluzioni || {}),
              children: (soluzione?.categorie || []).map((x) => ({
                pk: x.pk,
                name: x.title,
                image: x.mainImage,
                imageAlt: x.alt,
                url: x.url,
              })),
            }}
            theme="white"
            size="lg"
          />
        ) : (
          <CollezioniSection
            collezioni={collezioni}
            item={{
              name: t('Le nostre ultime collezioni'),
              ...(collezioni || {}),
            }}
            theme="white"
            handleClickTracking={handleClickTracking}
          />
        )}

        <CardSwiper
          id="soluzioni-correlati-swiper"
          item={{
            name: t('Esplora le altre soluzioni'),
            ...(correlatiMenu || {}),
            children: (soluzione?.correlati || []).map((x) => ({
              pk: x.pk,
              name: x.title,
              image: x.image,
              imageAlt: x.alt,
              url: x.url,
            })),
          }}
          theme="white"
          size="md"
        />
        <Prefooter />
      </main>
    </Page>
  )
}

export default SoluzioniDetailTemplate
